import { GuardError } from '../../../errors/GuardError';
import { showAlert } from '../../../slices/alertSlice';
import { EFirstMessageStatus } from '../../../types/firstMessageStatus';
import { TThunkAction } from '../../../types/redux/thunk';
import { ETelemetryEvents } from '../../../types/telemetry';
import { setFirstMessageUserChatsDisabled } from '../actions';
import { EFirstMessageResponseStatus, IAssertDependencies, Messages, TFirstMessageResponse } from '../types';

export const assertUserChatsDisabledStatus =
  (response: TFirstMessageResponse, { domain, telemetry }: IAssertDependencies): TThunkAction<void> =>
  (dispatch, _, { logger }) => {
    if (response.status === EFirstMessageResponseStatus.UserChatsDisabled) {
      telemetry.increment(ETelemetryEvents.ChatFirstMessageSendChatsDisabled);

      const message = Messages[EFirstMessageStatus.ChatsDisabled];

      dispatch(setFirstMessageUserChatsDisabled());
      dispatch(showAlert({ message }));

      const error = new GuardError({
        message,
        domain,
      });

      logger.error(error);
    }
  };
